import { initialState } from "./state";

export const setProfileStations = (state, payload) => {
  state.profileStations = payload;
};

export const reset = (state) => {
  const s = initialState();

  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
